var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.487,
    height: 14,
    viewBox: "0 0 11.487 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cart",
    transform: "translate(-1.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notifications-24px",
    d: "M9.744,16.5a1.44,1.44,0,0,0,1.436-1.436H8.308A1.435,1.435,0,0,0,9.744,16.5Zm4.308-4.308V8.6a4.374,4.374,0,0,0-3.231-4.537V3.577a1.077,1.077,0,0,0-2.154,0v.488A4.362,4.362,0,0,0,5.436,8.6v3.59L4,13.628v.718H15.487v-.718Z",
    transform: "translate(-2.744 -2.5)",
    fill: "#dedfe0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLogo);
export default __webpack_public_path__ + "static/media/NotificationLogo.f2b66ed43195c055f7126a85279e8ca1.svg";
export { ForwardRef as ReactComponent };